<template>
  <div id="lm-import-from-excel" v-if="isVisible">
    <p class="mb-3" v-if="label">{{ label }}</p>
    <div class="d-flex">
      <b-form-file
        v-model="excelFile"
        :state="Boolean(excelFile)"
        :id="id"
        :disabled="disabled"
        :placeholder="placeholder"
        drop-placeholder="Arrastra tu archivo aqui..."
        :accept="acceptFiles"
        @input="onFileUpload"
      ></b-form-file>
      <LmButton
        id="btn-import-excel"
        type="button"
        buttonClass="btn-primary ml-2 text-nowrap"
        :isProcessing="importIsProcessing"
        :value="importButtonText"
        @click.native="onImportExcel"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        icon="file-excel"
        :disabled="!Boolean(excelFile)"
      />
      <LmButton
        v-if="availableFields.length"
        id="btn-download-excel-example"
        type="button"
        buttonClass="btn-secondary ml-2 text-nowrap"
        :value="downloadExampleButtonText"
        @click.native="onDownloadExample"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        icon="download"
      />
    </div>
    <p
      v-if="rowsLength"
    >
      Se van a importar {{ rowsLength }} datos.
    </p>
  </div>
</template>

<script>
import { excel2json, json2excel } from 'js2excel'
import commonsApi from '@/api/commons'

import LmButton from '@/components/form/elements/LmButton'

import lmInputMixin from '@/mixins/lmInputMixin.js'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmInputMixin, lmToasts],
  components: {
    LmButton
  },
  props: {
    importButtonText: {
      type: String,
      default: 'Importar'
    },
    downloadExampleButtonText: {
      type: String,
      default: 'Descargar Ejemplo'
    },
    availableFields: {
      type: Array,
      default: () => []
    },
    customParams: {
      type: Array,
      default: () => []
    },
    pathForPostRequest: {
      type: String,
      default: '/'
    }
  },
  data () {
    return {
      excelFile: null,
      rowsLength: null,
      dataToImport: [],
      importIsProcessing: false,
      // Acepta ".numbers", ".xlsx" o ".xls"
      acceptFiles: 'application/x-iwork-keynote-sffnumbers,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  },
  methods: {
    onDownloadExample () {
      this.importIsProcessing = true
      try {
        if (this.availableFields.length) {
          const data = {}
          for (const af of this.availableFields) {
            data[af] = ''
          }
          json2excel({
            data: [data],
            name: 'lumbre-codificators-example'
          })
          this.lmToastSuccessMessage(`Se descargo un archivo de ejemplo correctamente!`, 'Acción exitosa', 2000)
        }
      } catch (error) {
        this.lmToastDangerMessage(error.message, 'Hubo un error', 2000)
      } finally {
        this.importIsProcessing = false
      }
    },
    onFileUpload (event) {
      excel2json([event], (data) => {
        this.importIsProcessing = true
        this.excelFile = event
        const pageName = Object.keys(data)[0]
        const rows = data[pageName]
        this.rowsLength = rows.length
        for (const row of rows) {
          // Elimino las columnas no permitidas
          if (this.availableFields.length) {
            for (const col in row) {
              if (!this.availableFields.some(af => af === col)) {
                delete row[col]
              }
            }
          }
          // Inserto parametros customs
          const paramsObject = {}
          if (this.customParams.length) {
            for (const param of this.customParams) {
              const value = isNaN(param.value) || param.value === '' ? param.value : Number(param.value)
              paramsObject[param.property] = value
            }
          }
          const obj = Object.assign(row, paramsObject)
          this.dataToImport.push(obj)
        }
        this.importIsProcessing = false
      }, 'excel2json')
    },
    async onImportExcel () {
      this.importIsProcessing = true
      try {
        if (this.dataToImport.length) {
          const promisesList = this.dataToImport.map(data => commonsApi.axiosPostWrapper(this.pathForPostRequest, data))
          await Promise.all(promisesList)
          this.lmToastSuccessMessage(`Se cargaron ${this.rowsLength} datos correctamente!`, 'Acción exitosa', 2000)
        }
      } catch (error) {
        console.log(error)
        this.lmToastDangerMessage(error.message, 'Hubo un error', 2000)
      } finally {
        this.importIsProcessing = false
      }
    }
  }
}
</script>
